import { Statistic } from "antd";
import React from "react";
import { useIntl } from "react-intl";

import "./AutoRenewal.less";

export type AutoRenewalProps = {
  autoRenewal: boolean,
}

export function AutoRenewal(props: AutoRenewalProps) {
  const { autoRenewal } = props;
  const intl = useIntl();
  const name = autoRenewal
    ? intl.formatMessage({ id: "jmix-store.auto-renewal.active" })
    : intl.formatMessage({ id: "jmix-store.auto-renewal.cancelled" });
  const style = autoRenewal ? "auto-renewal__status_active" : "";

  return (
    <Statistic
      className={style}
      title={intl.formatMessage({ id: "jmix-store.auto-renewal.title" })}
      value={name}
    />
  );
}